import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "min-h-screen w-full flex items-center justify-center bg-gray-100" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("main", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("div", { class: "bg-white shadow-lg rounded-xl p-8 max-w-lg text-center text-lg" }, [
      _createElementVNode("p", null, "Hier finden Sie den Link zum Trader:"),
      _createElementVNode("a", {
        href: "http://lardilla.zvni.com/",
        class: "text-blue-600 underline"
      }, " http://lardilla.zvni.com/ ")
    ], -1)
  ])))
}